import { connect } from 'react-redux'
import TripServiceList from '../../../components/trips/services/TripServiceList'
import { IStoreState, ITripPassengerDetail } from '../../../types'
import * as serviceActions from '../../../state/actions/services'
import * as tripServiceActions from '../../../state/actions/trips'

export function mapStateToProps(state: IStoreState, ownProps: any) {
  return {
    ...ownProps,
    rider: state.riders.items[ownProps.riderId],
    riderServiceProducts: state.tripRequest.settings.availableProducts,
    tripRequest: state.tripRequest.request,
    servicePricing: state.service.pricingType
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    fetchServicePricingType: (serviceId: string) => dispatch(serviceActions.fetchServicePricingType(serviceId)),
    fetchPaymentMethods: (serviceId: string) => dispatch(serviceActions.fetchPaymentMethods(serviceId)),
    setTripPassengerDetails: (passengerDetails: ITripPassengerDetail) =>
      dispatch(tripServiceActions.actionCreators.setTripPassengerDetails(passengerDetails)),
    updateRiderCount: (totalRider: number) => dispatch(tripServiceActions.actionCreators.updateRiderCount(totalRider))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TripServiceList)



// WEBPACK FOOTER //
// ./src/containers/trips/services/TripServiceList.ts